import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class BusinessRatingComponent extends Component {
  static readonly TYPE_ID: string = '56598c7161f743ebbfe3500202623d7b';

  constructor(
    public readonly totalScore: number,
    public readonly numberOfRatings: number,
  ) {
    super();
  }

  get rating(): number {
    return this.numberOfRatings > 0 ? (this.totalScore / this.numberOfRatings) : 0;
  }

  get $typeId(): string {
    return BusinessRatingComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static firstRating(rating: number): BusinessRatingComponent {
    return new BusinessRatingComponent(rating, 1);
  }

  static fromMap(context: SerializationContext, map: SerializedData): BusinessRatingComponent {
    return new BusinessRatingComponent(
        MapUtils.get<number>(map, 'totalScore'),
        MapUtils.get<number>(map, 'numberOfRatings'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'totalScore': this.totalScore,
      'numberOfRatings': this.numberOfRatings,
    };
  }

  clone(): this {
    return new BusinessRatingComponent(this.totalScore, this.numberOfRatings) as this;
  }

  isSame(other: BusinessRatingComponent): boolean {
    if(this === other) {
      return true;
    }

    return other.totalScore === this.totalScore && other.numberOfRatings === this.numberOfRatings;
  }

  addRating(rating: number): BusinessRatingComponent {
    return new BusinessRatingComponent(this.totalScore + rating, this.numberOfRatings + 1);
  }
}

export class BusinessRatingComponentBuilder extends DataModelBuilder<BusinessRatingComponent> {
  build(context: SerializationContext, map: SerializedData): BusinessRatingComponent {
    return BusinessRatingComponent.fromMap(context, map);
  }
}
